import { render, staticRenderFns } from "./newPromotion.vue?vue&type=template&id=46b678bf&scoped=true&"
import script from "./newPromotion.vue?vue&type=script&lang=js&"
export * from "./newPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b678bf",
  null
  
)

export default component.exports